import React from "react";
import {useFieldArray} from "react-hook-form";
import NestedArray from "./nestedFieldArray";
import {FormDialog, SelectElementModelFE, UseLocationStateModel} from "../../../api/types/generic";
import {Button, Card, CardContent, CardHeader, Grid, IconButton, useTheme} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CardContainer from "../../../common/components/CardContainer";
import {Delete} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import {RateSelectFE} from "../../../api/types/rate";
import {useLocation} from "react-router-dom";

export default function Fields({
                                   control,
                                   register,
                                   setValue,
                                   getValues,
                                   formDialog,
                                   handleChangeRate,
                                   rateList,
                                   locationGroupList,
                                   handleChangeLocationGroup,
                                   label,
                                   loadingUpdate
                               }: {
    control: any,
    register: Function,
    setValue: Function,
    getValues: Function,
    formDialog: FormDialog | null,
    handleChangeRate: Function,
    rateList: RateSelectFE[],
    locationGroupList: SelectElementModelFE[],
    handleChangeLocationGroup: Function,
    label: string,
    loadingUpdate: boolean
}) {
    const {fields, remove} = useFieldArray({
        control,
        name: "associations"
    });

    // Use Theme
    const theme = useTheme();

    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    // Use Location
    const location = useLocation();
    const locationState: UseLocationStateModel = location.state as UseLocationStateModel;

    function handleOperations(){
        if(getValues().productCode){
            return loadingUpdate;
        }
        return true;
    }

    return (
        <>
            {fields.map((item, index) => {
                return (
                    <Grid container spacing={2} p={2} key={item.id}>
                        <Grid item xs={12} sm={12}>
                            <Card>
                                <CardHeader
                                    sx={{backgroundColor: theme.palette.neutral.bright}}
                                    action={
                                        <IconButton aria-label="settings" color={"accent"} disabled={handleOperations()}
                                                    onClick={() => remove(index)}>
                                            <Delete/>
                                        </IconButton>
                                    }
                                    title={`${t("pricing:rateProductCodeLocationGroup.form.labels.productCode")}: ${label}`}
                                />

                                <CardContent>
                                    <Grid container spacing={2} rowSpacing={3}>
                                        <Grid item xs={12} md={3}>
                                            <NestedArray
                                                nestIndex={index}
                                                {...{
                                                    control,
                                                    register,
                                                    formDialog,
                                                    handleChange: handleChangeLocationGroup,
                                                    options: locationGroupList || [],
                                                    name: "locationGroup",
                                                    getValues,
                                                    readOnly: Boolean(formDialog?.readonly) || Boolean(formDialog?.inUse)
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <NestedArray
                                                nestIndex={index}
                                                {...{
                                                    control,
                                                    register,
                                                    formDialog,
                                                    options: rateList || [],
                                                    handleChange: handleChangeRate,
                                                    name: "rate",
                                                    getValues,
                                                    readOnly: Boolean(locationState?.locationGroupId) || Boolean(formDialog?.readonly) || Boolean(formDialog?.inUse)
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                );
            })}
            {!locationState?.locationGroupId &&
                <CardContainer>
                    <Grid item xs={12}>
                        <Grid container spacing={2} justifyContent={"center"} alignItems={"center"}>
                            <Grid item>
                                <Button size={"icon"}
                                        color={"accent"}
                                        onClick={() => {
                                            if(!handleOperations()) {
                                                setValue("associations", [
                                                    ...(getValues().associations),
                                                    {
                                                        locationGroup: [],
                                                        rate: []
                                                    }
                                                ]);
                                            }

                                        }}
                                        disabled={handleOperations()}
                                >
                                    <AddIcon/>
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </CardContainer>
            }
        </>
    );
}
